














































































































































































































































































































import { Component, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import MediateApi from '@/api/mediate'
import InvestigateApi from '@/api/investigate'
import PageLayout from '@/components/page/PageLayout.vue'
import { TOKEN } from '@/store/mutation-types'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import { columns } from './config'
import listMixins from '@/mixins/list'
import { download } from '@/utils/util'
import { ORDER_STATUS_DICT } from '@/web-task/config.ts'

@Component({
	name: 'mediateTaskList',
	components: {
		PageLayout,
	},
})
export default class TasksList extends Mixins(listMixins) {
	private columns: object = columns
	private data: any[] = []
	private visible: boolean = false
	private YI_QU_XIAO = ORDER_STATUS_DICT.YI_QU_XIAO
	private YI_GUAN_DAN = ORDER_STATUS_DICT.YI_GUAN_DAN

	private timer: any = ''
	private exportingList: boolean = false
	private exportingTask: boolean = false

	private get filteredStatus() {
		let temp: any[] = this.$store.state.setting.orderStatusList.filter(
			(item: any) => {
				return item.value !== '已完成'
			}
		)
		return [{ key: '', value: '全部' }]
			.concat(temp)
			.concat(this.$store.state.setting.conOrderStatusList)
	}

	private taskDetailPwd(action: any) {
		return `/AiiTasks/TasksDetail/${action.orderId}/${action.taskType}`
	}

	public getList() {
		return MediateApi.getList(this.getForm()).then((res: any) => {
			this.data = res.data.retList
			this.total = res.data.count
			this.resetSelected()
		})
	}

	public activated() {
		this.$store.dispatch('setting/initCompanyTree')
		this.$store.dispatch('setting/initAreas')
		this.getList()
		this.timer = setInterval(() => {
			if (Vue.ls.get(TOKEN)) {
				this.$ss.set('expandTime', 1)
				this.getList().finally(() => {
					this.$ss.remove('expandTime')
				})
			}
		}, 5 * 60 * 1000)
	}

	private addTask() {
		this.$router.push('/AiiTasks/addTask')
	}

	private deactivated() {
		clearInterval(this.timer)
	}

	private onTaskAdd() {
		this.resetPage()
		this.getList()
	}

	private getForm() {
		const form: any = this.getSearchValues()
		form.createTime =
			form.startendTime &&
			form.startendTime[0] &&
			form.startendTime[0].format('YYYY-MM-DD')
		form.endTime =
			form.startendTime &&
			form.startendTime[1] &&
			form.startendTime[1].format('YYYY-MM-DD')
		delete form.startendTime

		return form
	}

	private canAudit(action: any) {
		return (
			['04', '16'].includes(action.orderStatus) &&
			this.$auth('taskDetail:auditTask')
		)
	}

	private resend(orderId: string) {
		this.$confirm({
			title: '提示',
			content: '确认重新发送吗 ?',
			onOk: () => {
				return TaskApi.resendOrder(orderId).then((res: any) => {
					this.$message.success('发送成功')
					this.getList()
				})
			},
		})
	}

	private exportList() {
		this.exportingList = true
		MediateApi.exportList(this.getForm())
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exportingList = false
			})
	}

	private checkSelected() {
		if (!this.selected.length) {
			this.$message.error('请选择订单')
			return false
		}
		return true
	}
}
